"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("./LayoutComponents");
var LayoutStyles_1 = require("./LayoutStyles");
exports.PaneTitleTextStyle = {
    color: widgets_1.TabStyles.Typography.Color.Primary,
    fontSize: '15px',
};
exports.PaneTitlePositionStyle = {
    height: widgets_1.TabStyles.Sizing.RowHeight,
    lineHeight: widgets_1.TabStyles.Sizing.RowHeight + 'px',
    paddingLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.SmallSpace,
};
exports.PaneTitle = LayoutComponents_1.divWithStyle('PaneTitle', [exports.PaneTitleTextStyle, exports.PaneTitlePositionStyle]);
exports.DropdownLabel = LayoutComponents_1.divWithStyle('DropdownLabel', [exports.PaneTitleTextStyle, exports.PaneTitlePositionStyle, {
        paddingTop: widgets_1.TabStyles.Spacing.LargeSpace,
        paddingBottom: widgets_1.TabStyles.Spacing.DefaultSpace
    }]);
exports.DropdownSelectedItem = LayoutComponents_1.divWithStyle('DropdownSelectedItem', LayoutStyles_1.elideTextStyle);
exports.dropdownStyle = {
    maxWidth: 300,
};
exports.DropdownWrapper = LayoutComponents_1.divWithStyle('DropdownWrapper', {
    paddingLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.LargeSpace,
});
//# sourceMappingURL=SubplaceStyles.js.map